export function reportPageCount(state, payload) {
  if (!payload || !payload.sectionKey) return {};
  const current = state.pageCounts || {};
  if (current[payload.sectionKey] === payload.count) return {};
  return {
    pageCounts: { ...current, [payload.sectionKey]: payload.count },
  };
}
